var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconKebabMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.23,
    y: 180.22,
    width: 45.55,
    height: 45.55
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.23,
    y: 106.23,
    width: 45.55,
    height: 45.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.23,
    y: 30.23,
    width: 45.55,
    height: 45.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKebabMenu);
export default __webpack_public_path__ + "static/media/icon-kebab-menu.e44957bd.svg";
export { ForwardRef as ReactComponent };